import React from 'react';
import { Box, Divider, Grid, Typography } from '@mui/material';
import DefaultLogo from '@shared/assets/air/iconBlack.png';
import { convertToCamelCase } from '@shared/helpers';
import moment from 'moment';
import { sxStyle } from './styles';

const ItineraryFlightCard = ({ flight, id_option, idPrefix }) => {
  const details = [
    {
      idSuffix: 'aerolinea',
      isAirline: true,
      logo: flight.airline.logo || DefaultLogo,
      value: convertToCamelCase(
        flight.airline.description || flight.airline.code
      ),
    },
    {
      idSuffix: 'equipo',
      label: 'Equipo',
      value: flight?.equipment_description ?? '-',
    },
    {
      idSuffix: 'booking',
      label: 'Booking',
      value: `${flight.booking_class} (${flight.cabin})`,
    },
    {
      idSuffix: 'vuelo',
      label: 'Vuelo',
      value: `${flight.airline.code} ${flight.flight_number}`,
    },
  ];

  return (
    <Box id={idPrefix} sx={sxStyle.card}>
      {/* Header */}
      <Box sx={sxStyle.headerBox}>
        {details.map((item, i) => (
          <React.Fragment key={`box-header-${id_option}-${+i}`}>
            {i > 0 && (
              <Divider
                orientation="vertical"
                flexItem
                sx={sxStyle.dividerVertical}
              />
            )}
            <Grid
              id={idPrefix && `${idPrefix}-${item.idSuffix}`}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                px: 1,
                flex: 1,
                minWidth: 0,
              }}
            >
              {item.isAirline ? (
                <>
                  <Box
                    component="img"
                    src={item.logo}
                    alt="aerolinea"
                    key={'icon' + flight.airline.code + id_option}
                    sx={sxStyle.airlineLogo}
                  />
                  <Typography sx={sxStyle.valueText}>{item.value}</Typography>
                </>
              ) : (
                <>
                  <Typography sx={sxStyle.labelText}>{item.label}:</Typography>
                  <Typography sx={sxStyle.valueText}>{item.value}</Typography>
                </>
              )}
            </Grid>
          </React.Fragment>
        ))}
      </Box>

      <Grid sx={{ display: 'flex', justifyContent: 'center' }}>
        <Divider sx={sxStyle.dividerHorizontal} />
      </Grid>

      {/* Fechas y ciudades */}
      <Box sx={{ p: 2 }}>
        <Grid container>
          {[
            ['salida', flight.departure, flight.origin_obj.description],
            ['llegada', flight.arrival, flight.destination_obj.description],
          ].map(([idSuffix, time, location], i) => (
            <Grid
              key={`grid-location-${+i}`}
              id={idPrefix && `${idPrefix}-${idSuffix}`}
              item
              xs={6}
              textAlign="center"
            >
              <Typography sx={sxStyle.timeLocationText}>
                {moment(time).format('DD/MM/YYYY - HH:mm')}
              </Typography>
              <Typography sx={sxStyle.locationText}>{location}</Typography>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* Marca tarifaria */}
      {flight.brand_name && (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Divider sx={sxStyle.dividerHorizontal} />
          </Box>
          <Box id={idPrefix && `${idPrefix}-tarifa`} sx={sxStyle.operatedBox}>
            <Typography sx={sxStyle.operatedText}>
              {`Tarifa: ${flight.brand_name}`}
            </Typography>
          </Box>
        </>
      )}

      {/* Operado por otra aerolínea */}
      {flight.airline.code !== flight.operated && (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Divider sx={sxStyle.dividerHorizontal} />
          </Box>
          <Box
            id={idPrefix && `${idPrefix}-operado-por`}
            sx={sxStyle.operatedBox}
          >
            <Typography sx={sxStyle.operatedText}>
              {`Operado por ${
                flight.operated.description || flight.operated.code
              }`}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

export default ItineraryFlightCard;
